module.exports = __webpack_public_path__ + "img/IMG-4839.520aa34a.jpg";